import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  fetchKambiPendingTicketCount,
  fetchRacePendingTicketsCount,
  KambiPendingTicketsCountResponse,
  PendingTicketsCountResponse,
} from './api'

const enum LocalConstants {
  PollingTimeMs = 1_000 * 60 * 15, // 15mins
}

const pollingQueryOptions: Partial<UseQueryOptions> = {
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
} as const

// ======
// Racing
// ======

export const racingPendingTicketsQuery = queryOptions({
  queryKey: queryKeys.pendingTicketsCount,
  queryFn: fetchRacePendingTicketsCount,
})

export const racingPendingTicketsPollingQuery = {
  ...racingPendingTicketsQuery,
  ...(pollingQueryOptions as UseQueryOptions<PendingTicketsCountResponse>),
}

// =====
// Kambi
// =====

export const kambiPendingTicketsQuery = queryOptions({
  queryKey: queryKeys.kambiPendingTicketsCount,
  queryFn: fetchKambiPendingTicketCount,
})

export const kambiPendingTicketsPollingQuery = {
  ...kambiPendingTicketsQuery,
  ...(pollingQueryOptions as UseQueryOptions<KambiPendingTicketsCountResponse>),
} as const
